import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SubstitutionsApi } from "../../../api/substitutions";
import { Substitution } from "../../../api/types/substitutions";
import { QueryKey } from "../../../consts/query-keys";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { useFetchError } from "../../../hooks/useFetchError";
import { ApiError } from "../../../types/api-error";

export const useCreateSubstitution = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { handleSuccess } = useApiSuccess({
    snackbarText: "Substitution created.",
  });

  const mutationFn = (payload: Substitution) =>
    SubstitutionsApi.create(
      {
        path: { datasetId: payload?.DatasetId! },
      },
      payload,
    );

  const { mutate, error, isPending } = useMutation<
    unknown,
    ApiError,
    Substitution
  >({
    mutationKey: [QueryKey.Substitutions, "create"],
    mutationFn,
    onSuccess: (_data, variables) => {
      handleSuccess();
      queryClient.invalidateQueries({
        queryKey: [QueryKey.Substitutions, variables?.DatasetId],
      });
      onSuccess?.();
    },
  });

  useFetchError(error);

  return { createSubstitution: mutate, isPending };
};
